import { useMemo } from 'react';

import {
  computeCcrcProductMetrics,
  type CcrcTypeAProductMetrics,
} from '../lib/ccrc-type-a-metrics';
import type { CcrcCoverageType } from '../lib/ccrc-type-a-pricing';

export function useCcrcTypeAProductMetrics(
  products: CcrcTypeAProduct[],
  coverage: CcrcCoverageType,
  client: Client | null,
  partner: Client | null,
): Record<string, CcrcTypeAProductMetrics> {
  return useMemo(() => {
    if (!client) {
      return {};
    }

    return Object.fromEntries(
      products.map((product): [string, CcrcTypeAProductMetrics] => [
        product.id,
        computeCcrcProductMetrics({ product, coverage, client, partner }),
      ]),
    );
  }, [products, coverage, client, partner]);
}
